export default __webpack_public_path__ + "static/media/popup.5214193f.jpg";